import script from "./EventSetupPageEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSetupPageEdit.vue?vue&type=script&setup=true&lang=js"

import "./EventSetupPageEdit.vue?vue&type=style&index=0&id=6352d86b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6352d86b"]])

export default __exports__